"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = CheckBoxes;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _GenericStore = require("../store/GenericStore");

var _FormControlLabel = _interopRequireDefault(require("@material-ui/core/FormControlLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _ArrayHelper = require("../../../../../helpers/ArrayHelper");

function CheckBoxes(props) {
  var content = props.block.content,
      parentPath = props.parentPath,
      _props$isAutoSave = props.isAutoSave,
      isAutoSave = _props$isAutoSave === void 0 ? false : _props$isAutoSave,
      _props$onSubmit = props.onSubmit,
      onSubmit = _props$onSubmit === void 0 ? function () {
    return null;
  } : _props$onSubmit,
      isLogInArray = props.isLogInArray;

  var _useDataStore = (0, _GenericStore.useDataStore)(parentPath + '/value', []),
      _useDataStore2 = (0, _slicedToArray2["default"])(_useDataStore, 2),
      checked = _useDataStore2[0],
      setChecked = _useDataStore2[1];

  var handleChange = function handleChange(event, value) {
    var alreadyChecked = checked;

    if (event.target.checked) {
      alreadyChecked.push(value);
    } else {
      var index = alreadyChecked.indexOf(value);
      (0, _ArrayHelper.removeElementAtPosition)(alreadyChecked, index);
    }

    setChecked(alreadyChecked);

    if (isAutoSave && !isLogInArray) {
      onSubmit();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "ctnCheckBoxes"
  }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    component: "fieldset"
  }, content.map(function (checkbox, id) {
    return /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
      className: 'ctnCheckBoxItem',
      key: id,
      value: checkbox.value,
      control: /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        id: checkbox.value,
        checked: checked.indexOf(checkbox.value) !== -1,
        onChange: function onChange(evt) {
          return handleChange(evt, checkbox.value);
        }
      }),
      label: checkbox.label
    });
  })));
}